export const CA_ZIPCODES_WITH_DISCOUNT = [
    "95230",
    "93201",
    "93202",
    "93203",
    "93204",
    "93205",
    "93206",
    "93207",
    "93208",
    "93210",
    "93212",
    "93215",
    "93218",
    "93219",
    "93220",
    "93221",
    "93222",
    "93223",
    "93224",
    "93226",
    "93227",
    "93230",
    "93234",
    "93235",
    "93237",
    "93238",
    "93239",
    "93240",
    "93241",
    "93242",
    "93243",
    "93244",
    "93247",
    "93249",
    "93250",
    "93251",
    "93252",
    "93255",
    "93256",
    "93257",
    "93258",
    "93260",
    "93261",
    "93262",
    "93263",
    "93265",
    "93266",
    "93267",
    "93268",
    "93270",
    "93271",
    "93272",
    "93274",
    "93276",
    "93280",
    "93283",
    "93285",
    "93286",
    "93287",
    "93290",
    "93291",
    "93292",
    "93301",
    "93302",
    "93303",
    "93304",
    "93305",
    "93306",
    "93307",
    "93308",
    "93309",
    "93310",
    "93311",
    "93312",
    "93313",
    "93314",
    "93380",
    "93381",
    "93382",
    "93383",
    "93384",
    "93385",
    "93386",
    "93387",
    "93388",
    "93389",
    "93390",
    "93501",
    "93502",
    "93504",
    "93505",
    "93516",
    "93518",
    "93519",
    "93523",
    "93524",
    "93527",
    "93528",
    "93531",
    "93554",
    "93555",
    "93556",
    "93560",
    "93561",
    "93581",
    "93601",
    "93602",
    "93603",
    "93604",
    "93605",
    "93606",
    "93608",
    "93609",
    "93610",
    "93611",
    "93612",
    "93614",
    "93615",
    "93616",
    "93618",
    "93619",
    "93621",
    "93622",
    "93624",
    "93625",
    "93626",
    "93627",
    "93628",
    "93630",
    "93631",
    "93633",
    "93634",
    "93635",
    "93636",
    "93637",
    "93638",
    "93640",
    "93641",
    "93643",
    "93644",
    "93645",
    "93646",
    "93647",
    "93648",
    "93650",
    "93651",
    "93652",
    "93653",
    "93654",
    "93656",
    "93657",
    "93660",
    "93662",
    "93664",
    "93666",
    "93667",
    "93668",
    "93669",
    "93670",
    "93673",
    "93675",
    "93701",
    "93702",
    "93703",
    "93704", 
    "93705", 
    "93706", 
    "93707", 
    "93708", 
    "93709", 
    "93710",
    "93711", 
    "93712", 
    "93714", 
    "93715", 
    "93716", 
    "93717", 
    "93718", 
    "93720", 
    "93721", 
    "93722",
    "93723", 
    "93724", 
    "93725", 
    "93726", 
    "93727", 
    "93728", 
    "93729", 
    "93730", 
    "93737", 
    "93740",
    "93741", 
    "93744", 
    "93745", 
    "93747", 
    "93750", 
    "93755", 
    "93760", 
    "93761", 
    "93764", 
    "93765",
    "93771", 
    "93772", 
    "93773", 
    "93774", 
    "93775", 
    "93776", 
    "93777", 
    "93778", 
    "93779", 
    "93780",
    "93784", 
    "93786", 
    "93790", 
    "93792", 
    "93793", 
    "93794", 
    "93799",
    "95301", 
    "95303", 
    "95307", 
    "95312", 
    "95313", 
    "95315", 
    "95316", 
    "95317", 
    "95319", 
    "95322",
    "95323", 
    "95324", 
    "95326", 
    "95328", 
    "95333", 
    "95334", 
    "95340", 
    "95341", 
    "95348", 
    "95350",
    "95351", 
    "95354", 
    "95355", 
    "95356", 
    "95357", 
    "95358", 
    "95360", 
    "95361", 
    "95363", 
    "95365",
    "95367", 
    "95368", 
    "95369", 
    "95374", 
    "95380", 
    "95382", 
    "95385", 
    "95386", 
    "95387", 
    "95388"
]